//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.DrawShapes.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../GeometricUtilities/GeometricUtilities.TransformerData.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CanMoveToolOnly",1,0],[0,"CanRelocateToolToSelection",1,0],[0,"CanReorientToolToSelection",1,0],[0,"NumberOfCopies",1,0],[1,"ObjectsToTransform",0,"SelectNXObjectList",0],[0,"ResultOption",1,0],[0,"Scaling",1,0],[1,"Transformer",0,"GeometricUtilities.TransformerData",0]],[],[]];
SPLM.Features.DrawShapes.TransformData = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DrawShapes.TransformData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DrawShapes.TransformData.ScalingOptions = Object.freeze({
    "Linear" : "Linear", "Planar" : "Planar", "Uniform" : "Uniform"});

SPLM.Features.DrawShapes.TransformData.ResultOptions = Object.freeze({
    "MoveOriginal" : "MoveOriginal", "CopyOriginal" : "CopyOriginal"});

export default SPLM;